import store from "./services/store.js";
import axios from "axios";
import * as Sentry from "@sentry/vue";
export default {
  store: store,
  name: "App",
  created: function created() {
    var _this = this;

    var newsJsonUrl = process.env.VUE_APP_NEWS_JSON_URL || "/news.json";
    axios.get(newsJsonUrl).then(function (response) {
      _this.$store.dispatch("commitNews", response.data);
    }).catch(function (error) {
      console.log(error);
      Sentry.captureException(error);
    });
  },
  methods: {}
};